<div class="popup-search-container">
    <div class="search-header">
        <mat-form-field appearance="outline" class="operator-field">
            <mat-select [(value)]="selectedOperator">
                @for (option of operators; track option) {
                <mat-option [value]="option.code">{{ option.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <form (ngSubmit)="search()" [formGroup]="searchForm" class="search-form">
            <mat-form-field appearance="outline" class="search-input">
                <input matInput placeholder="{{ 'search' | translate }}" [formControl]="searchForm.get('search')" />
            </mat-form-field>
            <button mat-flat-button color="primary" class="search-button">{{ 'search' | translate }}</button>
        </form>
    </div>
    <div class="table-container">
        <div class="table-wrapper">
            <table mat-table [dataSource]="dataSource" class="search-table" id="htmlData" matSort>
                @for(column of visiableColumns; track column){
                <!-- <ng-container *ngFor="let column of displayedColumns"> -->
                <ng-container matColumnDef="{{ column }}">
                    <!-- action column -->
                    @if(column === 'actions') {
                    <th mat-header-cell *matHeaderCellDef>
                        {{ column | translate}}
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <button mat-flat-button color="primary" class="m-r-10"
                            (click)="selectedItem(row)">{{'select' | translate}}</button>
                    </td>
                    }
                  
                    @else {
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ column | translate}}
                        <button mat-button [matMenuTriggerFor]="menu" class="FilterButton">
                            <svg class="pc-icon">
                                <use xlink:href="assets/fonts/custom-icon.svg#filterSearch"></use>
                            </svg>
                        </button>
                        <mat-menu #menu="matMenu" [matMenuTriggerData]="{ disableClose: true }" [overlapTrigger]="false"
                            xPosition="after" yPosition="below">
                            <div mat-menu-item>
                                <input matInput class="form-control" (click)="$event.stopPropagation()"
                                    (keyup)="applyFilter($event, column)">
                            </div>
                        </mat-menu>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        @if(column === 'mobile' || column === 'phonenumber' ) {
                        <p class="w-100 px-3" style="direction: ltr">{{row[column]}}</p>
                        }
                        @else {
                        <p class="w-100 px-3">{{row[column]}}</p>
                        }
                    </td>
                }
                </ng-container>
                }
                <!-- } -->
                <!-- </ng-container> -->


                <!-- definition of header and row  -->
                <tr mat-header-row *matHeaderRowDef="visiableColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: visiableColumns; let i = index"
                    [class.even-row]="i % 2 === 0" [class.odd-row]="i % 2 !== 0"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="visiableColumns.length">{{'NoDatabyFilter' | translate}}</td>
                </tr>
            </table>
        </div>
    </div>

    <!-- paginator  -->
    <div class="paginator-container">
        <mat-paginator [length]="totalcount" [pageSize]="10" showFirstLastButtons>
        </mat-paginator>
    </div>
    <!-- end paginator region  -->
</div>